"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _date = require("@ha/date");

var _default = function _default(startDate, endDate) {
  var today = (0, _date.getToday)();
  var diffTodayStart = (0, _date.diffDay)(today, startDate);
  var diffTodayEnd = (0, _date.diffDay)(today, endDate);

  if (diffTodayStart < 0) {
    return {
      from: today,
      to: (0, _date.addDays)(startDate, -1)
    };
  }

  if (diffTodayEnd >= 0) {
    return {
      from: _date.NO_START,
      to: _date.NO_END
    };
  }

  return {
    from: _date.NO_START,
    to: _date.NO_START
  };
};

exports["default"] = _default;